import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@material-ui/core";
import React from "react";
import { ControllerRenderProps } from "react-hook-form";

export type ToggleProps = Omit<
  ControllerRenderProps<any, any>,
  "onBlur" | "name"
> & {
  className?: string;
  label?: React.ComponentProps<typeof FormControlLabel>["label"];
  error?: React.ComponentProps<typeof FormControl>["error"];
  helperText?: string;
  onBlur?: ControllerRenderProps<any, any>["onBlur"];
  name?: ControllerRenderProps<any, any>["name"];
  disabled?: boolean;
};

export const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  ({ label, className, helperText, error, value, onChange, ...props }, ref) => {
    return label ? (
      <FormControl error={!!error} className={className}>
        <FormControlLabel
          control={
            <Switch
              {...props}
              inputRef={ref}
              checked={!!value}
              onChange={onChange ? (e) => onChange(!value) : undefined}
              color="primary"
            />
          }
          label={label}
        />
        {!!helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    ) : (
      <Switch
        {...props}
        inputRef={ref}
        checked={!!value}
        onChange={onChange ? (e) => onChange(!value) : undefined}
        color="primary"
      />
    );
  }
);
